module.exports = __webpack_public_path__ + "static/media/CT_2019_30450.bdb1d977.png";